export { default } from './DepartmentCard';
